import { UserRoles } from "../../helpers/userRoles";
import TicketList from "../components/tickets/ticketList/ticketList";
import TicketDetails from "../components/tickets/ticketDetails/ticketDetails";
import TicketNotifications from "../components/tickets/ticketNotifications/ticketNotifications";
import AddTicket from "../components/tickets/addTicket/addTicket";
import OrderList from "../components/orders/orderList/orderList";
import OrderDetails from "../components/orders/orderDetails/orderDetails";
import OrderNotifications from "../components/orders/orderNotifications/orderNotifications";
import OrderTcr from "../components/orders/orderTcr/orderTcr";
import OrderStatus from "../components/orders/orderStatus/orderStatus";
import ModifyTcr from "../components/orders/orderTcr/modifyTcr/modifyTcr";
import ModifyTrailerDamages from "../components/orders/orderTcr/modifyTcr/modifyTrailerDamages/modifyTrailerDamages";
import OrderPhotos from "../components/orders/orderPhotos/orderPhotos";
import AddOrder from "../components/orders/addOrder/addOrder";
import ModifyOrder from "../components/orders/modifyOrder/modifyOrder";
import ModifyTicket from "../components/tickets/modifyTicket/modifyTicket";

export enum ticketRoutingAddress {
    list = "/transportation/ticket/list",
    details = "/transportation/ticket/details",
    notifications = "/transportation/ticket/notifications",
    add = "/transportation/ticket/add-ticket",
    modify = "/transportation/ticket/modify-ticket"
}

export enum orderRoutingAddress {
    list = "/transportation/order/list",
    details = "/transportation/order/details",
    notifications = "/transportation/order/notifications",
    tcr = "/transportation/order/tcr",
    modifyTcr = "/transportation/order/modify-tcr",
    modifyTrailerDamages = "/transportation/order/modify-trailer-damages",
    status = "/transportation/order/status",
    photos = "/transportation/order/photos",
    add = "/transportation/order/add-order",
    modify = "/transportation/order/modify-order"
}

export const ticketRoutes = [
    {
        path: ticketRoutingAddress.list,
        component: TicketList,
        roles: [UserRoles.ticketView]
    },
    {
        path: `${ticketRoutingAddress.details}/:id`,
        component: TicketDetails,
        roles: [UserRoles.ticketView]
    },
    {
        path: `${ticketRoutingAddress.notifications}/:id`,
        component: TicketNotifications,
        roles: [UserRoles.notificationsView]
    },
    {
        path: ticketRoutingAddress.add,
        component: AddTicket,
        roles: [UserRoles.ticketModification]
    },
    {
        path: `${ticketRoutingAddress.modify}/:id`,
        component: ModifyTicket,
        roles: [UserRoles.ticketModification]
    }
];

export const orderRoutes = [
    {
        path: orderRoutingAddress.list,
        component: OrderList,
        roles: [UserRoles.orderView]
    },
    {
        path: `${orderRoutingAddress.details}/:id`,
        component: OrderDetails,
        roles: [UserRoles.orderView]
    },
    {
        path: `${orderRoutingAddress.notifications}/:id`,
        component: OrderNotifications,
        roles: [UserRoles.notificationsView]
    },
    {
        path: `${orderRoutingAddress.tcr}/:id`,
        component: OrderTcr,
        roles: [UserRoles.tcrView]
    },
    {
        path: `${orderRoutingAddress.modifyTcr}/:id`,
        component: ModifyTcr,
        roles: [UserRoles.tcrModification]
    },
    {
        path: `${orderRoutingAddress.modifyTrailerDamages}/:orderId/:sideType`,
        component: ModifyTrailerDamages,
        roles: [UserRoles.tcrModification]
    },
    {
        path: `${orderRoutingAddress.status}/:id`,
        component: OrderStatus,
        roles: [UserRoles.orderStatusViewAndModification]
    },
    {
        path: `${orderRoutingAddress.photos}/:id`,
        component: OrderPhotos,
        roles: [UserRoles.orderPhotosView]
    },
    {
        path: orderRoutingAddress.add,
        component: AddOrder,
        roles: [UserRoles.orderModification]
    },
    {
        path: `${orderRoutingAddress.modify}/:id`,
        component: ModifyOrder,
        roles: [UserRoles.orderModification]
    }
];
